<template>
  <div class="crud">
    <DataTable :value="entities" selectionMode="single" :selection.sync="newUser" @row-select="onRowSelect"
               dataKey="_id" :paginator="true" :rows="15">
      <Column field="username" :header="$t('crud.user.labels.username')"></Column>
      <Column field="email" :header="$t('crud.user.labels.email')"></Column>
      <Column field="firstname" :header="$t('crud.user.labels.firstname')"></Column>
      <Column field="lastname" :header="$t('crud.user.labels.lastname')"></Column>
      <template #footer>
        <Button :label="$t('shared.actions.create')" icon="pi pi-plus" @click="createUser" class="p-button-primary" />
      </template>
    </DataTable>

    <Dialog :visible.sync="dialogVisible" :style="{width: '400px'}" :modal="true">
      <template #header>
        <span>{{ $t('crud.user.modals.titles.' + action) }}</span>
      </template>
      <div>
        <label for="username">{{ $t('crud.user.labels.username') }}</label>
        <input id="username" v-model="newUser.username" name="username" type="text">
      </div>
      <div>
        <label for="password">{{ $t('crud.user.labels.password') }}</label>
        <input id="password" v-model="newUser.password" name="password" type="text">
      </div>
      <div>
        <label for="email">{{ $t('crud.user.labels.email') }}</label>
        <input id="email" v-model="newUser.email" name="email" type="text">
      </div>
      <div>
        <label for="firstname">{{ $t('crud.user.labels.firstname') }}</label>
        <input id="firstname" v-model="newUser.firstname" name="firstname" type="text">
      </div>
      <div>
        <label for="lastname">{{ $t('crud.user.labels.lastname') }}</label>
        <input id="lastname" v-model="newUser.lastname" name="lastname" type="text">
      </div>
      <template #footer>
        <Button v-if="action === 'update'" :label="$t('shared.actions.delete')" icon="pi pi-trash" @click="deleteUser" class="p-button-danger"></Button>
        <Button :label="$t('shared.actions.save')" icon="pi pi-check" @click="saveUser" class="p-button-success"></Button>
        <Button :label="$t('shared.actions.cancel')" icon="pi pi-times" @click="cancelEdit" class="p-button-secondary"></Button>
      </template>
    </Dialog>
  </div>
</template>

<script>
  import DataTable from 'primevue/datatable';
  import Column from 'primevue/column';
  import Dialog from "primevue/components/dialog/Dialog";
  import Button from 'primevue/button';
  import User from '../../models/user.model';

  export default {
    name: 'Users',
    components: {
      Dialog,
      DataTable,
      Column,
      Button
    },
    props: {},
    data: () => {
      return {
        newUser: {},
        dialogVisible: false,
        action: '',
        entityName: ''
      }
    },
    computed: {
      entities() {
        return this.$store.state.users;
      }
    },
    methods: {
      onRowSelect: function(event) {
        this.action = 'update';
        this.newUser = {...event.data};
        this.dialogVisible = true;
      },
      createUser: function() {
        this.action = 'create';
        this.resetNewUser();
        this.dialogVisible = true;
      },
      deleteUser: function() {
        this.$store.dispatch('removeUser', this.newUser).then((succeed) => {
          if (succeed) {
            this.$toast.add({severity: 'success', summary: this.$t('crud.user.toasts_msg.summary.delete'),
                             detail: this.$t('crud.user.toasts_msg.success.delete'), life: 3000});
            this.dialogVisible = false;
            this.resetNewUser();
          } else {
            this.$toast.add({severity: 'error', summary: this.$t('crud.user.toasts_msg.summary.delete'),
                             detail: this.$t('crud.user.toasts_msg.fail.delete'), life: 3000});
          }
        });
      },
      saveUser: function () {
        if (
          this.$isNotEmpty(this.newUser.username)
          && this.$isNotEmpty(this.newUser.password)
          && this.$isNotEmpty(this.newUser.email)
          && this.$isNotEmpty(this.newUser.firstname)
          && this.$isNotEmpty(this.newUser.lastname)
        ) {
          let dispatch = 'postUser';
          if (this.action === 'update') {
            dispatch = 'updateUser';
          }

          this.$store.dispatch(dispatch, this.newUser).then((succeed) => {
            if (succeed) {
              this.$toast.add({severity: 'success', summary: this.$t('crud.user.toasts_msg.summary.save'),
                               detail: this.$t('crud.user.toasts_msg.success.save'), life: 3000});
              this.dialogVisible = false;
              this.resetNewUser();
            } else {
              this.$toast.add({severity: 'error', summary: this.$t('crud.user.toasts_msg.summary.save'),
                               detail: this.$t('crud.user.toasts_msg.fail.save'), life: 3000});
            }
          });
        } else {
          this.$toast.add({severity: 'error', summary: this.$t('crud.user.toasts_msg.summary.validation'),
                           detail: this.$t('crud.user.toasts_msg.validation.fieldsMissing'), life: 3000
          });
        }
      },
      resetNewUser: function () {
        this.newUser = new User({});
      },
      cancelEdit: function () {
        this.dialogVisible = false;
        this.newUser = new User({});
      }
    },
    created: function () {
      this.$store.dispatch('fetchAll');
      this.resetNewUser();
      this.entityName = this.$t('crud.user.user')
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .crud {
  }
</style>
